// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3vBHV","inputDescription":"styles_inputDescription__1w34u"};